@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

data class PassengerPointFilterDto(
    val favouriteLimit: Int? = null,
    val historyLimit: Int? = null,
    val suggestionsLimit: Int? = null,
    val passengerLat: Double? = null,
    val passengerLng: Double? = null,
)